<template>
  <section id="" class="match-making-wrapper body-content new-addendee-list">
    <div class="container-fluid spe_list">
      <div class="row">
        <div class="col-md-6 text-white">
          <h1 id="headerText" class="page-head text-uppercase mb-2 mt-lg-3">
            My Networks
          </h1>
          <p>Below are the possible matching based on your interests</p>
        </div>
        <div class="col-md-6 d-flex justify-content-end">
            <div class="speed-network d-flex align-items-center ">
                <div class="border-right">
                    Speed Networking
                </div>
                
                <div class="d-flex align-items-center ">
                     <img src="../../assets/Images/new-interface/stopwatch.svg"/>
                <span>
                   Starts in
                   <strong class="d-block">12:46</strong>
                </span>
                </div>
                
            </div>
        </div>
      </div>
      <!------>
      <div class="row attendee-list-box-wrapper">
        <div class="col-6 col-md-6 col-lg-3 col-elg-2 ate_list_main">
          <div
            class="
              attendee-box-hld
              new-list-show
              single-box-attendee-hld
              position-relative
            "
          >
            <div class="left-grid">
                <div class="attendee-presence-status position-relative">
<span class="attendee-status-bubble  attendee-online-status"></span>
              <div class="attendee-img-hld mx-0 mx-md-auto mx-sm-auto">
                <img
                  src="../../assets/Images/attendee.png"
                  alt="attendee"
                  class="imguserthumb"
                />
              </div>
                </div>
                

              <div class="attendee-des-hld">
                <h3>Richard H. Meyer</h3>
              </div>
            </div>
            <div class="center-grid">
              <div class="attendee-des-hld pt-0 attendee-technical-details">
                <p>VP, Omni Tech Solution</p>
                <p>Application Programmer</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6 col-md-6 col-lg-3 col-elg-2 ate_list_main">
          <div
            class="
              attendee-box-hld
              new-list-show
              single-box-attendee-hld
              position-relative
            "
          >
            <div class="left-grid">
                <div class="attendee-presence-status position-relative">
<span class="attendee-status-bubble  attendee-online-status"></span>
              <div class="attendee-img-hld mx-0 mx-md-auto mx-sm-auto">
                <img
                  src="../../assets/Images/attendee.png"
                  alt="attendee"
                  class="imguserthumb"
                />
              </div>
                </div>
                

              <div class="attendee-des-hld">
                <h3>Richard H. Meyer</h3>
              </div>
            </div>
            <div class="center-grid">
              <div class="attendee-des-hld pt-0 attendee-technical-details">
                <p>VP, Omni Tech Solution</p>
                <p>Application Programmer</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6 col-md-6 col-lg-3 col-elg-2 ate_list_main">
          <div
            class="
              attendee-box-hld
              new-list-show
              single-box-attendee-hld
              position-relative
            "
          >
            <div class="left-grid">
                <div class="attendee-presence-status position-relative">
<span class="attendee-status-bubble  attendee-online-status"></span>
              <div class="attendee-img-hld mx-0 mx-md-auto mx-sm-auto">
                <img
                  src="../../assets/Images/attendee.png"
                  alt="attendee"
                  class="imguserthumb"
                />
              </div>
                </div>
                

              <div class="attendee-des-hld">
                <h3>Richard H. Meyer</h3>
              </div>
            </div>
            <div class="center-grid">
              <div class="attendee-des-hld pt-0 attendee-technical-details">
                <p>VP, Omni Tech Solution</p>
                <p>Application Programmer</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6 col-md-6 col-lg-3 col-elg-2 ate_list_main">
          <div
            class="
              attendee-box-hld
              new-list-show
              single-box-attendee-hld
              position-relative
            "
          >
            <div class="left-grid">
                <div class="attendee-presence-status position-relative">
<span class="attendee-status-bubble  attendee-online-status"></span>
              <div class="attendee-img-hld mx-0 mx-md-auto mx-sm-auto">
                <img
                  src="../../assets/Images/attendee.png"
                  alt="attendee"
                  class="imguserthumb"
                />
              </div>
                </div>
                

              <div class="attendee-des-hld">
                <h3>Richard H. Meyer</h3>
              </div>
            </div>
            <div class="center-grid">
              <div class="attendee-des-hld pt-0 attendee-technical-details">
                <p>VP, Omni Tech Solution</p>
                <p>Application Programmer</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6 col-md-6 col-lg-3 col-elg-2 ate_list_main">
          <div
            class="
              attendee-box-hld
              new-list-show
              single-box-attendee-hld
              position-relative
            "
          >
            <div class="left-grid">
                <div class="attendee-presence-status position-relative">
<span class="attendee-status-bubble  attendee-online-status"></span>
              <div class="attendee-img-hld mx-0 mx-md-auto mx-sm-auto">
                <img
                  src="../../assets/Images/attendee.png"
                  alt="attendee"
                  class="imguserthumb"
                />
              </div>
                </div>
                

              <div class="attendee-des-hld">
                <h3>Richard H. Meyer</h3>
              </div>
            </div>
            <div class="center-grid">
              <div class="attendee-des-hld pt-0 attendee-technical-details">
                <p>VP, Omni Tech Solution</p>
                <p>Application Programmer</p>
              </div>
            </div>
          </div>
        </div>
       
      </div>
      <!------>
    </div>
  </section>
</template>
<script>
export default {
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>


